import {
    ChevronDownIcon,
    DotsHorizontalIcon,
    IdCardIcon,
    Pencil1Icon
} from '@radix-ui/react-icons';
import {
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable
} from "@tanstack/react-table";
import { useContext, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router';
import '../../App.css';
import { AuthContext } from '../../context/AuthContext';
import api from '../../lib/api';
import ChangeBunnyadminDialog from '../dialogs/changeBunnyadminDialog';
import ChangeClubRole from '../dialogs/changeClubRole';
import ChangeJudgeDialog from '../dialogs/changeJudgeDialog';
import ChangeSuperadminDialog from '../dialogs/changeSuperadminDialog';
import EmailAllDialog from '../dialogs/EmailAllDialog';
import ExportMembersDialog from '../dialogs/exportMembersDialog';
import MoveMemberDialog from '../dialogs/moveMemberDialog';
import SuspendMemberDialog from '../dialogs/suspendMemberDialog';
import UpdateMembershipDialog from '../dialogs/updateMembershipDialog';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import {
    Dialog
} from "../ui/dialog";
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { DataTable } from './datatable';
import DatatableSortButton from './datatableSortButton';


export const columns = (fetchClubMembers, auth, setSelectedUser, setDialogOpen) => [
    {
        accessorKey: "name",
        header: ({ column }) => <DatatableSortButton column={column}>Namn</DatatableSortButton>,
        cell: info => `${info.row.original.first_name} ${info.row.original.last_name}`,
    },
    {
        accessorKey: "birth_year",
        header: ({ column }) => <DatatableSortButton column={column}>Födelseår</DatatableSortButton>,
    },
    {
        accessorKey: "phone",
        header: ({ column }) => <DatatableSortButton column={column}>Telefon</DatatableSortButton>,
    },
    {
        accessorKey: "email",
        header: ({ column }) => <DatatableSortButton column={column}>E-post</DatatableSortButton>,
    },
    {
        accessorKey: "address",
        header: ({ column }) => <DatatableSortButton column={column}>Adress</DatatableSortButton>,
    },
    {
        accessorKey: "membership_started",
        header: ({ column }) => <DatatableSortButton column={column}>Startdatum</DatatableSortButton>,
        cell: info => {
            const user = info.row.original;
            const date = new Date(user.membership_started);
            if (user.suspended_reason || user.minimember) {
                return;
            }
            else {
                return date.toLocaleDateString('sv', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                });
            }
        }
    },
    // {
    //     accessorKey: "membership_expiration",
    //     header: ({ column }) => <DatatableSortButton column={column}>Utgångsdatum</DatatableSortButton>,
    //     cell: info => {
    //         const user = info.row.original;
    //         if (user.suspended_reason) {
    //             return (
    //                 <>
    //                     <Badge  variant='destructive'>Inaktiverad</Badge>
    //                     {user.minimember && <Badge className='ml-2'>Mini</Badge>}
    //                 </>
    //             );
    //         } else if (user.minimember) {
    //             return <Badge >Mini</Badge>;
    //         } else {
    //             const date = new Date(user.membership_expiration);
    //             return date.toLocaleDateString('sv', {
    //                 year: 'numeric',
    //                 month: '2-digit',
    //                 day: '2-digit',
    //             });
    //         }
    //     }
    // },
    {
        accessorKey: "membership_expiration",
        header: ({ column }) => <DatatableSortButton column={column}>Utgångsdatum</DatatableSortButton>,
        cell: info => {
            const user = info.row.original;
            if (user.suspended_reason) {
                return (
                    <>
                        <Badge variant='destructive'>Inaktiverad</Badge>
                        {user.minimember && <Badge className='ml-2'>Mini</Badge>}
                    </>
                );
            } else if (user.minimember) {
                return <Badge>Mini</Badge>;
            } else {
                const expirationDate = new Date(user.membership_expiration);
                const currentDate = new Date();
                const oneMonthBeforeExpiration = new Date(expirationDate);
                oneMonthBeforeExpiration.setMonth(oneMonthBeforeExpiration.getMonth() - 1);

                // Determine text color class based on expiration date
                let textColorClass = '';
                if (currentDate > expirationDate) {
                    textColorClass = 'text-red-600 font-semibold';  // Expired
                } else if (currentDate > oneMonthBeforeExpiration) {
                    textColorClass = 'text-yellow-600 font-semibold';  // Less than a month before expiration
                }

                return (
                    <span className={textColorClass}>
                        {expirationDate.toLocaleDateString('sv', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                        })}
                    </span>
                );
            }
        }
    },
    {
        accessorKey: "role",
        header: ({ column }) => <DatatableSortButton column={column}>Roll</DatatableSortButton>,
    },
    {
        id: "actions",
        enableHiding: false,
        cell: ({ row }) => {
            const user = row.original;
            return (
                <Dialog modal={true}>
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button variant="ghost" className="h-8 w-8 p-0 float-right">
                                <span className="sr-only">Öppna meny</span>
                                <DotsHorizontalIcon className="h-4 w-4" />
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end" onCloseAutoFocus={(e) => {
                            e.preventDefault();
                        }}>
                            <DropdownMenuLabel>Alternativ</DropdownMenuLabel>
                            <DropdownMenuSeparator />
                            <DropdownMenuItem onSelect={(event) => {
                                event.preventDefault();
                            }}>
                                <Link to={`/profile/${user.id}`} className='flex items-center'>
                                    <Pencil1Icon className='mr-3' />
                                    Ändra användarinformation
                                </Link>
                            </DropdownMenuItem>
                            {/* <UpdateMembershipDialog user={user} fetchClubMembers={fetchClubMembers} /> */}
                            <DropdownMenuItem
                                onClick={() => {
                                    setSelectedUser(user);
                                    setDialogOpen(true);
                                }}
                                className='cursor-pointer'
                            >
                                <IdCardIcon className='mr-3' />
                                Uppdatera medlemsskap
                            </DropdownMenuItem>
                            <DropdownMenuSeparator />
                            <ChangeClubRole user={user} fetchClubMembers={fetchClubMembers} />
                            {auth?.user?.superadmin && (
                                <>
                                    <ChangeJudgeDialog user={user} fetchClubMembers={fetchClubMembers} />
                                    <ChangeBunnyadminDialog user={user} fetchClubMembers={fetchClubMembers} />
                                    <ChangeSuperadminDialog user={user} fetchClubMembers={fetchClubMembers} />
                                </>
                            )}
                            <DropdownMenuSeparator />
                            <SuspendMemberDialog user={user} fetchClubMembers={fetchClubMembers} />
                        </DropdownMenuContent>
                    </DropdownMenu>
                </Dialog>
            );
        }
    },
];

export function MemberDataTable({ clubId }) {
    const [sorting, setSorting] = useState([]);
    const [members, setMembers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [columnFilters, setColumnFilters] = useState([]);
    const [filterInput, setFilterInput] = useState("");
    const { auth } = useContext(AuthContext);

    const [showSuspendedUsers, setShowSuspendedUsers] = useState(false);
    const [showExpiredUsers, setShowExpiredUsers] = useState(false);

    const [selectedUser, setSelectedUser] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);

    const [columnVisibility, setColumnVisibility] = useState(() => {
        const savedVisibility = localStorage.getItem('memberDatatableColumnVisibility');
        if (savedVisibility) {
            return JSON.parse(savedVisibility);
        }
        // Otherwise, use default settings
        return {
            name: true,
            birth_year: true,
            phone: false,
            email: true,
            address: false,
            membership_started: true,
            membership_expiration: true,
            role: true,
        };
    });

    useEffect(() => {
        localStorage.setItem('memberDatatableColumnVisibility', JSON.stringify(columnVisibility));
    }, [columnVisibility]);

    const fetchClubMembers = async () => {
        try {
            const response = await api.get(`https://skhrf-api.cmdigital.se/v1/clubs/members?clubId=${clubId}`);
            const membersWithName = response.data.members.map(member => ({
                ...member,
                name: `${member.first_name} ${member.last_name}`
            }));

            setMembers(membersWithName);
        } catch (error) {
            console.error('Error fetching members:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchClubMembers();
    }, [clubId]);

    const handleSuspendedChange = () => {
        setShowSuspendedUsers(prev => !prev);
    };

    const handleExpiredChange = () => {
        setShowExpiredUsers(prev => !prev);
    };

    const filteredMembers = useMemo(() => {
        const result = members.filter(member => {
            const isSuspended = member.suspended_reason;
            const isMiniMember = member.minimember;
            const isExpired = new Date(member.membership_expiration) < new Date();

            // Always include active, unsuspended users, and minimembers
            if ((!isSuspended && !isExpired) || (isMiniMember && !isSuspended)) {
                return true;
            }
            // Include suspended users if the checkbox is checked
            if (isSuspended && showSuspendedUsers) {
                return true;
            }
            // Include expired users if the checkbox is checked
            if (isExpired && showExpiredUsers) {
                return true;
            }
            // Otherwise, exclude the user
            return false;
        });

        return result;
    }, [members, showSuspendedUsers, showExpiredUsers]); // Dependencies for memoization

    // Delay function before filtering to reduce bounce
    useEffect(() => {
        const handler = setTimeout(() => {
            table.getColumn("name")?.setFilterValue(filterInput);
            let test = table.getColumn("membership_expiration").setFilterValue();

        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [filterInput]);

    const table = useReactTable({
        // The code that is commented out breaks the invite dialog when the table is empty
        // data: filteredMembers.length > 0 ? filteredMembers : [],
        data: filteredMembers,
        columns: columns(fetchClubMembers, auth, setSelectedUser, setDialogOpen),
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        onColumnFiltersChange: setColumnFilters,
        getFilteredRowModel: getFilteredRowModel(),
        onColumnVisibilityChange: setColumnVisibility,
        state: {
            sorting,
            columnFilters,
            columnVisibility,
        },
    });

    // Human readable names
    const columnNameMapping = {
        name: "Namn",
        birth_year: "Födelseår",
        phone: "Telefon",
        email: "E-post",
        address: "Adress",
        membership_started: "Startdatum",
        membership_expiration: "Utgångsdatum",
        role: "Roll",
        actions: "Verktyg",
    };

    return (
        <>
            <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3 py-3'>
                <UpdateMembershipDialog user={selectedUser} fetchClubMembers={fetchClubMembers} isDialogOpen={dialogOpen} setIsDialogOpen={setDialogOpen} onlyMount={true} />
                <div className='flex gap-3'>
                    <Input
                        id='searchUser'
                        placeholder="Sök användare..."
                        value={filterInput}
                        disabled={isLoading || members.length === 0}
                        onChange={event => setFilterInput(event.target.value)}
                        className="max-w-sm"
                        autoComplete='off'
                    />
                    <div className='flex items-center gap-2'>
                        <Label className='flex gap-2 items-center'>
                            <Checkbox
                                checked={showSuspendedUsers}
                                onCheckedChange={handleSuspendedChange}
                                disabled={isLoading || members.length === 0}
                                className='bg-white'
                            />
                            Avstängda
                        </Label>
                        <Label className='flex gap-2 items-center'>
                            <Checkbox
                                checked={showExpiredUsers}
                                onCheckedChange={handleExpiredChange}
                                disabled={isLoading || members.length === 0}
                                className='bg-white'
                            />
                            Utgångna
                        </Label>
                    </div>
                </div>
                <div className='grid grid-cols-2 xl:col-start-3 gap-3'>
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button variant="outline" disabled={isLoading || members.length === 0} >
                                Kolumner <ChevronDownIcon className="ml-2 h-4 w-4" />
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end" className='dropdown-content-width-full'>
                            <DropdownMenuLabel>Kolumner</DropdownMenuLabel>
                            <DropdownMenuSeparator />
                            {table
                                .getAllColumns()
                                .filter((column) => column.getCanHide())
                                .map((column) => {
                                    const headerText = columnNameMapping[column.id] || column.id;

                                    return (
                                        <DropdownMenuCheckboxItem
                                            key={column.id}
                                            className="cursor-pointer"
                                            checked={column.getIsVisible()}
                                            onCheckedChange={(value) =>
                                                column.toggleVisibility(!!value)
                                            }
                                        >
                                            {headerText}
                                        </DropdownMenuCheckboxItem>
                                    );
                                })}
                        </DropdownMenuContent>
                    </DropdownMenu>
                    <Dialog modal={true}>
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button variant='secondary'><DotsHorizontalIcon className='mr-3' /> Verktyg</Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent className='dropdown-content-width-full' onCloseAutoFocus={(e) => {
                                e.preventDefault();
                            }}>
                                <DropdownMenuLabel>Verktyg</DropdownMenuLabel>
                                <DropdownMenuSeparator />
                                <MoveMemberDialog clubId={clubId} fetchClubMembers={fetchClubMembers} />
                                <EmailAllDialog members={members} />
                                <ExportMembersDialog members={members} clubId={clubId} />
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </Dialog>
                </div>
            </div>
            <DataTable table={table} isLoading={isLoading} columns={columns(fetchClubMembers, auth, setSelectedUser, setDialogOpen)} skeletonRows={10} />
        </>
    );
}